import React, { Component, Fragment } from 'react';
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from 'reactstrap';
import { Header } from '../../components/layout/Auth/Header';
import { Loader } from '../../components/layout/Loader/Loader';
import {GlobalNotification} from "../../components/layout/Messages/GlobalNotification";

class Auth extends Component {
  componentDidMount() {
    document.documentElement.scrollTop = 0;

    if (document && document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    } else if (document && document.documentElement) {
      document.documentElement.scrollTop = 0;
    }

    this.refs.mainContent.scrollTop = 0;
    document.body.classList.add('bg-default');
  }

  componentWillUnmount() {
    document.body.classList.remove('bg-default');
  }

  render() {
    return (
      <Fragment>
        <Loader align="text-center" verticalAlign="middle" />
        <div className="main-content" ref="mainContent">
          <Header title={ this.props.title } lead={ this.props.lead }/>
          <Container className="mt--8 pb-5">
            <Row className="justify-content-center">
              <Col lg="5" md="7">
                <Card className="bg-secondary border-0 mb-0">
                  <CardBody className="px-lg-5 py-lg-5">
                    { this.props.children }
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <GlobalNotification/>
      </Fragment>
    );
  }
}

export { Auth };
